
export default {
  title: 'hola Intelligential',
  register: {
    required: 'Requerido',
    registerButton: 'Registrar',
    registerTitle: 'Registrate',
    seePassword: 'Ver contraseñas',
    legalNameLabel: 'Razón social',
    rfcLabel: 'RFC',
    emailLabel: 'Correo de contacto',
    contactNameLabel: 'Nombre',
    contactLastNameLabel: 'Apellidos',
    passwordLabel: 'Contraseña',
    confirmPasswordLabel: 'Confirma tu contraseña',
    legalNamePlaceholder: 'Introduce la razón social de tu empresa',
    rfcPlaceholder: 'Introduce el RFC de tu empresa',
    emailPlaceholder: 'Introduce tu correo electrónico',
    contactNamePlaceholder: 'Introduce tu nombre',
    contactLastNamePlaceholder: 'Introduce tus apellidos',
    legalNameDataVV: 'Razón social',
    rfcDataVV: 'RFC',
    emailDataVV: 'Correo',
    contactNameDataVV: 'Nombre',
    contactLastNameDataVV: 'Apellidos',
    passwordDataVV: 'Contraseña',
    confirmPasswordDataVV: 'de confirmación',
    contractNumber: 'No. de contrato',
    contractNumberPlaceholder: 'Introduce tu no. de contrato',
    contractNumberDataVV: 'No. de contrato'
  },
  roles: {
    admin: 'Administrador',
    analyst: 'Analista',
    compliance: 'Oficial de cumplimiento',
    manager: 'Manager',
    viewer: 'Revisor',
    custom: 'Personalizado',
    developer: 'Desarrollador',
    treasury: 'Tesorería',
    legal: 'Legal',
    intelligential: 'Intelligential',
    accounting_manager: 'Gerente de contabilidad',
    banking_manager: 'Gerente de tesorería',
    credit_manager: 'Gerente de crédito',
    customer_manager: 'Gerente comercial'
  },
  steps: {
    welcome: 'Bienvenido a Intelligential',
    products: 'Productos',
    pipeline: 'Flujos',
    forms: 'Formularios',
    configurationPipeline: 'Configuración del pipeline de análisis',
    confirmation: 'Confirmación',
    step: 'Paso {stepNumber}',
    nextStep: 'Siguiente',
    beforeStep: 'Anterior',
    step1: {
      title: 'Registra tu primer producto',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel ex tortor. Vestibulum at nibh ut massa consectetur feugiat aliquet sit amet massa. In et purus a sem lacinia placerat. Fusce vel iaculis odio. Nam lacinia efficitur volutpat. In dapibus eros ac bibendum pulvinar. Nullam commodo pulvinar facilisis. Fusce bibendum enim at tortor pharetra posuere.',
      configure: 'Configura tus productos',
      recommended: 'Productos recomendados',
      amounts: 'Montos',
      columnsTable: {
        name: 'Nombre',
        creditType: 'Tipo de crédito',
        interest: 'Cálculo de interés',
        collectionType: 'Tipo de cobro',
        collectionPeriod: 'Periodo de cobro',
        detail: 'Detalle',
        empty: 'Sin productos',
        status: 'Estatus',
        actions: 'Acciones',
        minAmount: 'Monto mínimo',
        maxAmount: 'Monto máximo'
      }
    },
    step2: {
      title: 'Crea el primer flujo de trabajo para {productName}',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel ex tortor. Vestibulum at nibh ut massa consectetur feugiat aliquet sit amet massa. In et purus a sem lacinia placerat. Fusce vel iaculis odio. Nam lacinia efficitur volutpat. In dapibus eros ac bibendum pulvinar. Nullam commodo pulvinar facilisis. Fusce bibendum enim at tortor pharetra posuere.',
      newFlow: 'Configura nuevo pipeline',
      titleMessage: 'Configura tus pipelines',
      returnStep: 'Regresar a la lista de pipelines',
      confirm: 'Confirmar',
      addStep: 'Añadir nueva etapa',
      flowModelTitle: 'Pipeline de negocio',
      productLabel: 'Producto:',
      pipelineLabel: 'Agregar flujo',
      pipelineNameLabel: 'Nombre del flujo',
      pipelineNamePlaceholder: 'Ingresa el nombre del flujo',
      pipelineDescriptionLabel: 'Descripción',
      pipelineDescriptionPlaceholder: 'Ingresa una breve descripción',
      addButtonPipelineInfo: 'Agregar',
      withoutPipelineMessage: 'Primero agrega el flujo en la parte superior',
      legalNameLabel: 'Nombre del documento legal'
    },
    step3: {
      title: 'Formularios para tu producto {productName}',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel ex tortor. Vestibulum at nibh ut massa consectetur feugiat aliquet sit amet massa. In et purus a sem lacinia placerat. Fusce vel iaculis odio. Nam lacinia efficitur volutpat. In dapibus eros ac bibendum pulvinar. Nullam commodo pulvinar facilisis. Fusce bibendum enim at tortor pharetra posuere.'
    },
    step4: {
      title: 'Resumen de configuración',
      messageCongratulations: 'Haz finalizado la configuración con éxito'
    }
  },
  pipelines: {
    titles: {
      list: 'Mis procesos de análisis',
      add: 'Agregar pipeline',
      edit: 'Editar {pipelineName}',
      flows: 'Pipelines'
    },
    buttons: {
      add: 'Nuevo pipeline',
      save: 'Guardar'
    },
    forms: {
      pipelineName: 'Nombre del pipeline',
      description: 'Descripción',
      flows: 'Edición del pipeline'
    },
    tables: {
      flowName: 'Nombre del pipeline',
      description: 'Descripción',
      createdBy: 'Creado por',
      createdAt: 'Fecha de creación',
      actions: 'Acciones',
      preconfigured: 'Pre configurado',
      system: 'Sistema',
      select: 'Seleccionar',
      empty: 'Sin pipelines'
    }
  },
  configuration: {
    titlePage: 'Configuración',
    commissions: {
      title: 'Comisiones'
    },
    prelation: {
      title: 'Prelación de pagos',
      commission: 'Comisiones',
      commissionTax: 'IVA de comisiones',
      insurance: 'Seguro',
      defaultInterest: 'Interés moratorio',
      interest: 'Interés',
      principal: 'Capital',
      interestTax: 'IVA del interés',
      insuranceTax: 'IVA del seguro',
      defaultInterestTax: 'IVA del interés moratorio',
      interestOrder: 'Interés de orden',
      interestOrderTax: 'Iva de interés de orden'
    }
  },
  paymentDetail: {
    principalBalance: 'Capital',
    interestBalance: 'Intereses',
    interestTaxBalance: 'IVA del interes',
    defaultInterestBalance: 'Intereses moratorio',
    defaultInterestTaxBalance: 'IVA de intereses moratorio',
    insuranceBalance: 'Seguro',
    insuranceTaxBalance: 'IVA del seguro',
    commissionBalance: 'Comisiones',
    commissionTaxBalance: 'IVA de comisiones'
  },
  documentsTemplateType: {
    account_statement: 'Estado de cuenta',
    account_statement_revolvent: 'Estado de cuenta revolvente',
    invoice: 'Factura',
    contract: 'Contrato',
    contract_cover: 'Carátula',
    application: 'Solicitud',
    promissory_note: 'Pagaré',
    withdrawal_notice: 'Aviso de disposición',
    payroll_discount: 'Carta de instrucción',
    checklist: 'Checklist',
    withdrawal_note: 'Comprobante de egreso',
    amortization_table: 'Tabla de amortización',
    conditions: 'Condiciones',
    authorization: 'Autorización comité',
    authorization_risk: 'Autorización comité riesgos',
    risk: 'Matriz de riesgo crediticio',
    risk_aml: 'Matriz de riesgo PLD',
    settlement: 'Carta finiquito',
    agreement_remainder: 'Recordatorio de incumplimiento',
    payment_agreement: 'Acuerdo de pago',
    privacity_note: 'Aviso de privacidad',
    account_statement_invoice: 'Factura estado de cuenta',
    black_list_report: 'Reporte de lista negra',
    simulated_ideal_table: 'Tabla ideal simulada',
    theoretical_amortization_table: 'Tabla teórica de amortización',
    payments_table: 'Tabla real de pagos',
    payment_complement: 'Complemento de pago',
    credit_opinion: 'Opinión de crédito',
    account_statemen_monto_control: 'Estado de cuenta monto control',
    legal_analysis: 'Análisis legal',
    megacontract: 'Megacontrato',
    risk_evaluation_module_historic: 'Histórico del módulo de evaluación de riesgos',
    quote: 'Cotización',
    general_report: 'Reporte general',
    attachment: 'Anexo',
    pre_committee: 'Precomité'
  },
  emailTypes: {
    welcome_user: 'Bienvenida a nuevo usuario',
    reset_password: 'Restablecer contraseña',
    password_changed: 'Contraseña cambiada',
    aml_customer_alert: 'Alerta AML al cliente',
    aml_customer_report: 'Reporte AML del cliente',
    aml_payment_amount_alert: 'Alerta por monto AML',
    aml_blockedPerson_alert: 'Alerta de persona bloqueada AML',
    aml_country_noncooperative_alert: 'Alerta de país no cooperante AML',
    prequalification_application_end: 'Fin de solicitud de precalificación',
    application_end: 'Fin de solicitud',
    invoice: 'Factura',
    pre_committee_document_generated: 'Documento generado para precomité',
    application_rejected: 'Solicitud rechazada',
    offer_accepted: 'Oferta aceptada',
    offer_released: 'Oferta liberada',
    application_next_stage: 'Liberación de etapa',
    prequalification_rejected: 'Precalificación rechazada',
    prequalification_accepted: 'Precalificación aprobada',
    amortization_table: 'Tabla de amortización / Cotización',
    register_user: 'Registro de nuevo usuario',
    register_broker_user: 'Registro de broker nuevo',
    reset_password_broker_user: 'Restablecer contraseña de broker',
    bulk_download: 'Descarga masiva',
    new_application_created: 'Nuevo cliente registrado',
    upload_document_type: 'Nuevo documento cargado',
    document_requested_on_register: 'Documento solicitado en registro',
    change_step_application: 'Cambio de etapa en solicitud',
    user_accept_offer: 'Usuario acepta oferta',
    register_user_with_detail: 'Registro de usuario con detalle',
    sign_document: 'Firma de documento',
    accounting_journal: 'Diario contable',
    register_broker: 'Registro de broker',
    lead_validation: 'Validación de lead',
    register_financial_user: 'Registro de usuario financiero',
    offer_voter: 'Votante de oferta',
    resend_lead_validation: 'Reenviar validación de lead',
    account_statement: 'Estado de cuenta',
    user_account_block: 'Bloqueo de cuenta de usuario',
    collection: 'Cobranza',
    aml_risk_activity_alert: 'Alerta de actividad de riesgo AML',
    disabled_email_account: 'Cuenta de correo deshabilitada',
    invoice_report: 'Reporte de factura',
    massive_event_send_confirmation: 'Confirmación de envío masivo',
    start_disposition: 'Inicio de disposición',
    start_disperse_disposition: 'Inicio de disposición dispersada',
    layout_beneficiaries_status: 'Layout de beneficiarios por estatus',
    contract_error: 'Error en proceso de contrato',
    disperse_commission_agents: 'Dispersión a comisionistas',
    code_otp: 'Código OTP',
    resend_buro_code: 'Reenvío de código de buró',
    send_otp: 'Enviar OTP de aplicación',
    eprc: 'Reporte EPRC',
    ebr: 'Reporte EBR',
    ebr_started: 'EBR iniciado',
    signed_document: 'Documento firmado',
    account_statement_financial: 'Estado de cuenta financiero',
    application_stage_end: 'Etapa finalizada',
    formalize_offer: 'Formalización de oferta',
    user_affiliation: 'Afiliación de usuario',
    notification_document_ai: 'Notificación de documento AI'
  },
  types: {
    company: 'Empresa',
    client: 'Cliente'
  },
  cmsContentType: {
    credit_history: 'Historial créditicio',
    fiscal_information: 'Información fiscal',
    privacy_notice: 'Aviso de privacidad',
    completed_prequalification_message: 'Finalizar proceso de precalificación',
    completed_application_message: 'Finalizar proceso de solicitud',
    product_detail: 'Resumen de producto '
  }
}
